module.exports = __webpack_public_path__ + "static/media/banner.2a77e90a.png";